import React, {Component} from 'react';
import moment from 'moment';

class Footer extends Component {
	render() {
		return (
			<footer className="main-footer">
				<strong>
					Copyright &copy; { moment().format('YYYY') }
					<a href="http://ptiqcs.com" target="_blank" rel="noopener noreferrer"> PTIQCS </a>
				</strong>
				All rights reserved.
				<div className="pull-right hidden-xs">
					<b>Version</b> 3.0.0
				</div>
			</footer>
		)
	}
}

export default Footer